//------------------------------------------------- PLUGINS
var app;

(function($){
    app = {
        //------------------------------------------------- ON READY
        init: function() {
            // Popups
            $('.js--dismiss-popup').on('click', function(e){
                e.preventDefault();

                var $el = $('.js--popup'),
                    cookie = 'subscribe_popup';

                $el.removeClass('is--visible');
                $el.delay(250).fadeOut(0, function(){
                    Cookies.set(cookie, true, { expires: 60 });
                    $el.removeClass('is--active');
                });
            });
            
            // Cart toggle
            $('.js--toggle-cart').off().on('click', function(e) {
                e.preventDefault();
                e.stopImmediatePropagation();

                if($(this).hasClass('is--open')) {
                    $(this).removeClass('is--open');
                    $('.js--cart-modal').removeClass('is--open');
                    $('.js--cart-modal').fadeOut(250);
                } else {
                    $('.js--cart-modal').fadeIn(250);
                    $(this).addClass('is--open');
                    $('.js--cart-modal').addClass('is--open');
                }

                if(!$(this).hasClass('is--open')) {
                    $('body').removeClass('is--modal');
                } else {
                    $('body').addClass('is--modal');
                }
            });

            // Close cart on click
            $('.js--cart-modal').on('click', function(e) {
                if($(e.target).is(this)) {
                    $(this).removeClass('is--open');
                    $('.js--toggle-cart').removeClass('is--open');
                    $(this).fadeOut(250);
                }

                if(!$('.js--toggle-cart').hasClass('is--open')) {
                    $('body').removeClass('is--modal');
                }
            });

            // Open Cart on add
            $(document).on('cart.requestComplete', function(event, cart) {
                $('.js--cart-modal').fadeIn(250);
                $(this).addClass('is--open');
                $('.js--cart-modal').addClass('is--open');
                $('body').addClass('is--modal');
            });
        },
        //------------------------------------------------- USER INTERACTIONS
        interactive: function() {

            $('.js-scroll-nav').on('click', function(e) {
                e.preventDefault();

                var id = $(this).attr('href'),
                    offset = $(id).offset();
                
                $('html, body').animate({
                    scrollTop: offset.top
                }, 500);
            });

            // Product Info
            $('.js-read-more').on('click', function(e) {
                e.preventDefault();

                var id = $(this).attr('href');

                $('.theme--product-listings').addClass('is-viewing');

                console.log($('.theme--product-listing'+id));

                if($('.theme--product-listing').hasClass('is-active')) {
                    $('.theme--product-listing.is-active').find('.js-desc').slideUp(250, function() {
                        $('.theme--product-listing.is-active').removeClass('is-active');

                        $('.theme--product-listing'+id).addClass('is-active');
                        $('.theme--product-listing'+id).find('.js-desc').slideDown(250);
                    });
                    console.log('second');
                } else {
                    $('.theme--product-listing'+id).addClass('is-active');
                    $('.theme--product-listing'+id).find('.js-desc').slideDown(250);

                    console.log('first');
                }
            });

            $(document).on('click', function(e) {
              if (!$(e.target).closest('.theme--product-listing.is-active').length) {
                $('.theme--product-listings').removeClass('is-viewing');
                $('.theme--product-listing.is-active').find('.js-desc').slideUp(250, function() {
                    $('.theme--product-listing.is-active').removeClass('is-active');
                });
              }
            });
            
        },
        //------------------------------------------------- PLUGINS
        plugins: function() {

            // Modaal Gallery
            $('.js--modaal-gallery').modaal({
                type: 'image',
                background: '#3b48ed',
                overlay_opacity: 0.9,
                animation_speed: 250,
                background_scroll: false
            });
        },
        //------------------------------------------------- ADD TO CART FORM
        addToCart: function(id, options, product) {

            // Selectors
            var $form = $(id),
                $option_selector = $form.find('.js--select-option'),
                $selected = $form.find('.js--active-variant'),
                $selected_title = $form.find('.js--active-variant-title'),
                $add_btn = $form.find('.js--add-to-cart');

            // HTML
            var slash = ' <span>/</span> ';

            // Variables
            var v = product.variants,
                step = [],
                selections = options;

            // Functions
            function displayText(array, step) {
                // Provide display text for selections made
                var filtered = [];

                for (d_i = 0; d_i < array.length; d_i++) {
                    if (d_i < step) {
                        filtered.push(array[d_i]);
                    }
                }

                if (filtered.length < selections.length) {
                    return filtered.join(slash) + slash;
                } else {
                    return filtered.join(slash);
                }
            }
            function varCheck(array) {
                // Filter the variants
                var filtered = [];

                for (v_i = 0; v_i < array.length; v_i++) {
                    filtered.push(array[v_i]);
                }

                return filtered.toString();
            }
            function selCheck(array, index, value) {
                // Filter the selections
                var filtered = [];

                for (s_i = 0; s_i < array.length; s_i++) {
                    if (s_i === index) {
                        filtered.push(value);
                    } else {
                        filtered.push(array[s_i]);
                    }
                }

                return filtered.toString();
            }

            // Update selections on change
            $option_selector.on('change', function(e) {
                var row = $(this).data('option'),
                    row_clicked = row + 1,
                    value = $(this).val();

                // Update the current selections
                selections[row] = value;

                // Add an entry to the step array
                if (step.length === row && step.length < selections.length) {
                    // Step up
                    step.push('Step '+row_clicked);
                }

                // Update the fields
                $option_selector.each(function( n, el ) {
                    var $el = $(el),
                        el_index = $el.data('option'),
                        el_val = $el.val();

                    // Only run this on rows outside the clicked row
                    if (el_index != row) {
                        // Disable the select first
                        $el.prop('disabled', true);

                        // Enable the select if 
                        for (i = 0; i < v.length; i++) {
                            if (varCheck(v[i].options) === selCheck(selections, el_index, el_val) && v[i].available) {
                                $el.prop('disabled', false);
                            }
                        }
                    }
                });

                // Update the selected variant if the correct number of choices has been made
                if (step.length === selections.length) {
                    // Set the active variant
                    for (i = 0; i < v.length; i++) {
                        if (v[i].options.toString() === selections.toString() && v[i].available) {
                            // Update Actve Variant
                            $selected.val(v[i].id);

                            // Update Add To Cart button
                            $add_btn.text('Add to cart - '+Shopify.formatMoney(v[i].price, '${{amount_no_decimals}}'));
                            $add_btn.prop('disabled', false);
                        }
                    }
                }

                // Lead through steps if each option hasn't been selected yet
                if (step.length === row_clicked && step.length < selections.length) {
                    $form.find('.js--option-set-'+(step.length+1)).removeClass('is--disabled');
                }

                // Update labels
                if (step.length === selections.length) {
                    $selected_title.html(displayText(selections, step.length));
                } else {
                    $selected_title.html(displayText(selections, step.length) + 'Select a '+product.options[step.length]+'!');
                }
            });
        }
    };

    $(document).ready(function(){
        app.init();
        app.interactive();
        app.plugins();
    });
})(jQuery);